/** CoStar.Api.Brokers.ViewModels.Search.SortField */
export var SortField;
(function (SortField) {
    SortField[SortField["Default"] = 0] = "Default";
    SortField[SortField["LastName"] = 1] = "LastName";
    SortField[SortField["FirstName"] = 2] = "FirstName";
    SortField[SortField["Title"] = 3] = "Title";
    SortField[SortField["Company"] = 4] = "Company";
    SortField[SortField["Phone"] = 5] = "Phone";
    SortField[SortField["Email"] = 6] = "Email";
    SortField[SortField["Address"] = 7] = "Address";
    SortField[SortField["City"] = 8] = "City";
    SortField[SortField["State"] = 9] = "State";
    SortField[SortField["DealCount"] = 10] = "DealCount";
    SortField[SortField["DealSF"] = 11] = "DealSF";
    SortField[SortField["LeaseRepProperties"] = 12] = "LeaseRepProperties";
    SortField[SortField["LeaseRepRBA"] = 13] = "LeaseRepRBA";
    SortField[SortField["SaleTransferCount"] = 14] = "SaleTransferCount";
    SortField[SortField["SaleTransferAmount"] = 15] = "SaleTransferAmount";
    SortField[SortField["SoldTotalValueRecent"] = 16] = "SoldTotalValueRecent";
    SortField[SortField["Submarket"] = 17] = "Submarket";
    SortField[SortField["FullName"] = 18] = "FullName";
    SortField[SortField["PrimaryExpertise"] = 19] = "PrimaryExpertise";
    SortField[SortField["PostalCode"] = 20] = "PostalCode";
    SortField[SortField["NumberOfBrokers"] = 101] = "NumberOfBrokers";
    SortField[SortField["PropertiesForSaleCount"] = 102] = "PropertiesForSaleCount";
    SortField[SortField["PropertiesForSaleValue"] = 103] = "PropertiesForSaleValue";
    SortField[SortField["SoldCount"] = 104] = "SoldCount";
    SortField[SortField["SoldValue"] = 105] = "SoldValue";
    SortField[SortField["SpaceTotalSf"] = 106] = "SpaceTotalSf";
    SortField[SortField["SpacesCount"] = 107] = "SpacesCount";
    SortField[SortField["LeaseDealCountRecent"] = 108] = "LeaseDealCountRecent";
    SortField[SortField["LeaseDealSfRecent"] = 109] = "LeaseDealSfRecent";
    SortField[SortField["ForSaleTotalSf"] = 110] = "ForSaleTotalSf";
    SortField[SortField["SoldTotalSfRecent"] = 111] = "SoldTotalSfRecent";
    SortField[SortField["SoldTransactionCountRecent"] = 112] = "SoldTransactionCountRecent";
    SortField[SortField["LeaseSignDate"] = 200] = "LeaseSignDate";
    SortField[SortField["Floor"] = 201] = "Floor";
    SortField[SortField["TotalSfLeased"] = 202] = "TotalSfLeased";
    SortField[SortField["RentSfYr"] = 203] = "RentSfYr";
    SortField[SortField["Services"] = 204] = "Services";
    SortField[SortField["TenantName"] = 205] = "TenantName";
    SortField[SortField["RentType"] = 206] = "RentType";
    SortField[SortField["SpaceUse"] = 207] = "SpaceUse";
    SortField[SortField["LeaseType"] = 208] = "LeaseType";
    SortField[SortField["LeaseDealType"] = 209] = "LeaseDealType";
    SortField[SortField["MoveInDate"] = 210] = "MoveInDate";
    SortField[SortField["LeaseTermType"] = 211] = "LeaseTermType";
    SortField[SortField["LeaseExpirationDate"] = 212] = "LeaseExpirationDate";
    SortField[SortField["ListingCompany"] = 213] = "ListingCompany";
    SortField[SortField["ListingContact"] = 214] = "ListingContact";
    SortField[SortField["TenantRepCompany"] = 215] = "TenantRepCompany";
    SortField[SortField["TenantRepContact"] = 216] = "TenantRepContact";
    SortField[SortField["LeaseStatus"] = 217] = "LeaseStatus";
    SortField[SortField["MonthsOnMarket"] = 218] = "MonthsOnMarket";
    SortField[SortField["FreeRent"] = 219] = "FreeRent";
    SortField[SortField["FreeMonths"] = 220] = "FreeMonths";
    SortField[SortField["StartDate"] = 221] = "StartDate";
    SortField[SortField["Suite"] = 222] = "Suite";
    SortField[SortField["BuildingRating"] = 223] = "BuildingRating";
    SortField[SortField["MiddleInitial"] = 400] = "MiddleInitial";
    SortField[SortField["NamePrefix"] = 401] = "NamePrefix";
    SortField[SortField["Expertise"] = 402] = "Expertise";
    SortField[SortField["Market"] = 403] = "Market";
})(SortField || (SortField = {}));
/** CoStar.Api.Brokers.ViewModels.Search.NewSortType */
export var NewSortType;
(function (NewSortType) {
    NewSortType[NewSortType["Default"] = 0] = "Default";
    NewSortType[NewSortType["Ascending"] = 1] = "Ascending";
    NewSortType[NewSortType["Descending"] = 2] = "Descending";
})(NewSortType || (NewSortType = {}));
/** CoStar.Api.Brokers.ViewModels.Search.GeographyFilterType */
export var GeographyFilterType;
(function (GeographyFilterType) {
    GeographyFilterType[GeographyFilterType["Unknown"] = 0] = "Unknown";
    GeographyFilterType[GeographyFilterType["PostalCode"] = 2] = "PostalCode";
    GeographyFilterType[GeographyFilterType["City"] = 3] = "City";
    GeographyFilterType[GeographyFilterType["ResearchMarket"] = 7] = "ResearchMarket";
    GeographyFilterType[GeographyFilterType["County"] = 10] = "County";
    GeographyFilterType[GeographyFilterType["Subdivision"] = 11] = "Subdivision";
})(GeographyFilterType || (GeographyFilterType = {}));
/** CoStar.Api.Brokers.ViewModels.Search.BrokerTypes */
export var BrokerTypes;
(function (BrokerTypes) {
    BrokerTypes[BrokerTypes["None"] = 0] = "None";
    BrokerTypes[BrokerTypes["InvestmentSale"] = 1] = "InvestmentSale";
    BrokerTypes[BrokerTypes["LandlordRep"] = 2] = "LandlordRep";
    BrokerTypes[BrokerTypes["TenantRep"] = 4] = "TenantRep";
})(BrokerTypes || (BrokerTypes = {}));
/** CoStar.Api.Brokers.ViewModels.Search.PropertySupertypes */
export var PropertySupertypes;
(function (PropertySupertypes) {
    PropertySupertypes[PropertySupertypes["None"] = 0] = "None";
    PropertySupertypes[PropertySupertypes["Hospitality"] = 1] = "Hospitality";
    PropertySupertypes[PropertySupertypes["Industrial"] = 2] = "Industrial";
    PropertySupertypes[PropertySupertypes["Land"] = 4] = "Land";
    PropertySupertypes[PropertySupertypes["Office"] = 8] = "Office";
    PropertySupertypes[PropertySupertypes["GeneralRetail"] = 16] = "GeneralRetail";
    PropertySupertypes[PropertySupertypes["Flex"] = 32] = "Flex";
    PropertySupertypes[PropertySupertypes["SportsAndEntertainment"] = 64] = "SportsAndEntertainment";
    PropertySupertypes[PropertySupertypes["Specialty"] = 128] = "Specialty";
    PropertySupertypes[PropertySupertypes["Multifamily"] = 256] = "Multifamily";
    PropertySupertypes[PropertySupertypes["Healthcare"] = 512] = "Healthcare";
    PropertySupertypes[PropertySupertypes["Residential"] = 1024] = "Residential";
    PropertySupertypes[PropertySupertypes["ShoppingCenter"] = 2048] = "ShoppingCenter";
})(PropertySupertypes || (PropertySupertypes = {}));
/** CoStar.Api.Brokers.ViewModels.Search.PropertyTypes */
export var PropertyTypes;
(function (PropertyTypes) {
    PropertyTypes[PropertyTypes["None"] = 0] = "None";
    PropertyTypes[PropertyTypes["Hospitality"] = 1] = "Hospitality";
    PropertyTypes[PropertyTypes["Industrial"] = 2] = "Industrial";
    PropertyTypes[PropertyTypes["Land"] = 4] = "Land";
    PropertyTypes[PropertyTypes["Office"] = 8] = "Office";
    PropertyTypes[PropertyTypes["GeneralRetail"] = 16] = "GeneralRetail";
    PropertyTypes[PropertyTypes["Flex"] = 32] = "Flex";
    PropertyTypes[PropertyTypes["SportsAndEntertainment"] = 64] = "SportsAndEntertainment";
    PropertyTypes[PropertyTypes["Specialty"] = 128] = "Specialty";
    PropertyTypes[PropertyTypes["Multifamily"] = 256] = "Multifamily";
    PropertyTypes[PropertyTypes["Healthcare"] = 512] = "Healthcare";
})(PropertyTypes || (PropertyTypes = {}));
/** CoStar.Api.Brokers.ViewModels.Search.SortType */
export var SortType;
(function (SortType) {
    SortType[SortType["Default"] = 0] = "Default";
    SortType[SortType["NameAscending"] = 1] = "NameAscending";
    SortType[SortType["NameDescending"] = 2] = "NameDescending";
})(SortType || (SortType = {}));
